module.exports = {
    lang: {
        CN: '中文',
        EN: 'English'
    },

    login: {
        title: "Sign up",
        user_sign_in: "Welcome",
        welcome_to_login: "Welcome to sign",
        //slogan: "iPassBill",
        password: "Password",
        auto_login_7_days: 'Auto-login within 7 days',
        forget_pwd: "Forgot password?",
        register_tip: "No account? Sign up now.",
        sign_in: "Sign in",
        previous: "Back"
    },

    login_footer: {
        name:'iPassWallet',
        copy_right: "All Rights Reserved",
    },

    

    two_fa_code:{
        pls_enter_code:'Please enter your 2-Step Authentication code.',
        tips:'Check your code in Authenticator App.',
        need_bind_text:'You need to enable 2-Step Authentication to access all functions.！',  

        text1:'Please open the corresponding Authenticator app on your mobile phone and scan this barcode to set up your account',
        text2:'Please open the corresponding Authenticator app on your mobile phone and enter this barcode to set up your account',        
        text3:'Change to scan bar code', 
        text4:'Change to manually enter the code',  
        next:'Next', 
        bind_now:"Bind Now",  
        limit:'No Permission!', 
        contactus:'Contact Us',
        download:'Download',
        developer:'Developer',
        recommend:'Recommend',
        question:'How to set up 2-Step Authentication?',
        step1:'Step 1: Search and install any of the following APPs from Apple Store or Google Play based on the type of the phone you are using.',
        step2:'Step 2: Open the installed APP above, and click "Bind Now" button at the top of this page. Use the installed APP to scan the QR code in the dialog box, or manually enter the barcode number. Once completed,  there are 6 numbers in APP interface that change randomly over time, as shown in figure:',
        step3:'Step 3: Click "Next" button in the dialog box, and enter 6 numbers appeared in the APP. If it prompts “Operation Success", the 2-Step Authentication has been completed. Please keep the APP and verification code properly. You will need it when you log into the platform or perform some sensitive operations in future.'

    },


    register: {
        free_register: 'Free Register Now!',
        slogan: "Enter a valid email and nickname to register immediately！",
        company_account: "ISP",
        personal_account: "Affiliate ",
        actype: "Account",
        step1: "Choose account type",
        step2: "Validate your email and submit",        
        fill_information: "Please fill out all the information below",
        pls_fill_isp_name: "ISP Name",
        image_captcha: "Captcha",
        email_captcha: "Email OTP",
        pls_fill_captcha: "Email Code",
        password: "Password",
        sign_up: "Sign up",
        login_tip: "Already registered an account?",
        first_name: "First Name",
        last_name: "Last Name",
        send_captcha: "Send Email OTP",
        resend: 'Resend after',
        name: 'Name',        
        created_account:'Create your {name} account now!',

    },

    // forget: {
    //     confirm_password: "Confirm Password",
    //     confirm_change: "Confirm",
    //     retrieve_pwd: "Reset password?",
    //     retrieve_pwd_easy: '通过向注册邮箱发送OTP，轻松重置登录密码。'
    // },

    forget: {
        confirm_password: "Confirm Password",
        confirm_change: "Confirm Change",
        retrieve_pwd: "Reset your login password",
        retrieve_pwd_easy: 'Easy to reset the password by sending an OTP to the registered email.  ',
        get_pwd:'Remember your password?'

    },



    home: {
        account_info: "Profile",
        account_balance: "BAL*",
        balance: "BAL*",
        withdraw: "Withdraw",
        deposit: "Deposit",
        transfer: "Send Money",
        collection: "Request Money",
        notice: "Notice",
        overview_of_today: "SUM* of TDY's Trading",
        deposit_of_today: "Deposit",
        withdraw_of_today: "Withdraw",
        transfer_of_today: "Transfer Out",
        collection_of_today: "Transfer In",
        conversion_in_of_today: " Buy Forex",
        conversion_out_of_today: " Sell Forex",
        transfer_list: "Transfer List",
        collection_list: "Collection List",
        swap_list: "List",
        withdraw_list: "Withdrawal List",
        deposit_list: "Deposit List",
        unit: "",
        calcuated_at:'Calculated at',
        overviews_of_days:'Overview of {days} days',
    },

     // 导航
    menu: {
        home: "Home",   //jan
        apps:'My APP',   //jan
        apps_info:'My App Info',
        transaction:'My Transactions', //jan


        chargeback:'My Chargeback',
        ban:'My Ban List',


        all:'All', 
        refundedlist:'Refunded',
        chargebacklist:'Chargeback',
        banlist:'Banned',
        fraudlist:'Fraud',
        withdraw: "Withdraw",
        

        rolling:'Rolling Reserve', //jan
        statement: 'My Statement', //jan
        monthly_report:'Monthly Report',
        notice: 'System Notice', //jan
        // shipping: 'Shipping', //jan
        shipping: 'Orders Delivery', //jan
        shipping_list:"Orders Delivery List",
        black:'My Blacklist', //jan
        white:'My Whitelist', //jan
        merchant_manage: 'Merchant',
        account:'Account Management',
        merchant:'Merchant Management',
        child_account:'Sub Account',

        
        // withdraw:'Withdrawal Management',
        // rolling:'Rolling Reserve',
        // statement:'Statement Management',

        // business_manage: 'Transactions',
        // business:'Transaction List',
        // expresslist:'Delivery Management',

        // config_manage:'Configuration',
        // config:'Global Configuration',
        // exchange:'Exchange Management',
        // channel:'Channel Management',
        // mid:'Channel MID',

        // other_manage: 'Others',
        // notice:'System Notice',
        
        // ban:'Ban List',
        


        // admin_manage:'Administration',
        // member:'Administrator List',
        // role:'Role Management',
        // log:'Log Management',
            
        seeting: "Settings",
        change_lang: "Change Language",
        logout: "Sign Out",

    },

    
    common: {
        email: "Email",
        no_data: "No data yet~",
        hello: "Hello",
        currency: "Currency",
        amount: "AMT*",
        fee: "Transaction Fee",
        confirm_transaction: "Confirm the Transaction",
        trading_situation: "Transaction Overview",
        enter_pay_pwd: "Enter Payment Password",
        confirm: "Confirm",
        helpful_hints: "Tips",  //Jan
        transaction_reference: "Transaction Reference",
        transaction_date: "Transaction Date",
        payee: 'Payee',
        payer: 'Payer',
        go_back: "Back",
        cancel: "Cancel",
        name:'Account Name',
        street: 'Street',
        postcode: 'Postcode',
        legal_person_data: "Legal Person Info",
        address: "Address",
        amtinfo: "Uer Info",
        networkerror:'NetworK Error',
        close: 'Close',
        refresh: 'Refresh',
        checkInfo:'Check Info',
        note:'Note',
        system_update:'System is under maintenance and upgrades.',
        index_app_tips:'You need to add at least one APP to get APP ID before starting API integration! <span class="uk-text-primary">Click here.</span>',
        click:'Click here.',
        withdraw_mode:'The funds is cleared by the third party payment service provider or the acquiring bank directly!',
        auto_mode:'Automatic settlement'
    },

    






    form: {
        ok:'Ok',        
        type:'Type',
        save: 'Save',
        search: "Search",
        clear_con: "Clear",
        submit: "Submit",
        confirm: "Confirm",
        pls_select: "Please select",
        date: 'Datetime',
        email:'Email',
        time_range: "Time Range",
        status: "Status",
        amount_range: "AMT* Range",
        amount_min: "Min. AMT*",
        amount_max: "Max. AMT*",
        merchant_no:'MERCH ID',
        currency:'Currency',
        app_name:'App Name',
        app_id:'APP ID',
        card_no:'Card NO.',
        credit_card:'Credit Card NO.',
        order_time:'ORD Time',
        update_time:'Update Time',

        created_at:'Created at',
        released_at:'(EST*) Released at',  //jan确认      


        ms_no:'Ref. No.',
        serial_no:'Ref. No.',
        relevant_no:'Relevant Ref. No.',
        statement_type:'Statement Type',
        channel:'Channel',
        order_no:'ORD NO.',
        merchant_order_no:'MERCH ORD NO.',
        gateway_order_no:'Gateway ORD NO.',
        front_six:'First 6 digits',
        back_four:'Last 4 digits',
        company_name:'Company Name',
        shipping_no:'Shipping NO.',
        channel_id:'Channel ID',
        channel_version:'Channel Version',        
        merchant_subject:"Merchant Info",
        merchant_subject_title:"Merchant",        
        merchant_id:'Channel ID',
        channel_merchant:'Channel MID',        
        bill_desc:'Billing Descriptor',
        title:'Title',
        is_visible:'IsVisible',
        content:'Content',
        black_type:'BlackList Type',
        ban_code:'Ban Code',
        ban_desc:'Ban Description',
        nick_name:'Nick Name',
        is_available:'IsAvailable',
        ip_address:'IP address',
        ip:"IP",
        time_zone:'Time Zone',
        first_lang:'Language',
        lang:'Language',
        company_name_2:'Company Name',
        balance:'BAL*',
        balance_range:'BAL* Range',        
        frozen:'Frozen',
        fee:'Fee',
        released:'Pending release of RR*',
        country:'Country',
        services_cate:'Industry',
        statement_id:'Ref. No.',
        released_money:'Released AMT*',
        released_time:'Released Time',
        balance_change:'BAL* Change',
        frozen_moeny:'Frozen AMT*',
        frozen_moeny_index:"Frozen BAL*",
        frozen_moeny_change:'Frozen AMT* Change',
        business_type:'Business Type',
        remark:'Remark',
        customer:'Customer',
        merchant:'Merchant',
        channel_name:'Channel Name',
        channel_title:'Channel Info',

        web_site:'Website',
        api_resourse:'API Resources',
        express_name:'Shipping Company',
        express_web:'Tracking Site',
        upload_time:'Upload Time',
        exchange:'ROE',
        exchange_tips:'Only currency marked as settlement currency can be settled for merchant.',
        is_settle_currency:'Settlement Currency',
        support_currency:'Supported Currency',
        support_card_type:'Support Card Type',
        is_available_refound:'Partial Refund',
        is_active:'IsActive',
        admin_team:'Admin Team',
        express_time_range:'Delivered Time Range',
        creat_busniess_time_range:'ORD Time Range',
        chargeback_busniess_time_range:'Chargeback Time Time Range',
        refund_busniess_time_range:'Refund Time Time Range',


        is_csv:"Create CSV File" ,
        download_csv:'Download Csv',
        yes:'Yes',
        no:'No',
        create_time:'Create Time',
        api_title:'API Info',
        api_version:'API Version',
        api_secret:'API Secret',
        contact:'Contact',
        merchant_bill_desc:'MERCH Billing Info',
        admin:'Admin',
        add_exchange:'Add',
        update_exchange:'Update',
        is_set_exchange_tips:'Currency can no longer be reset as non-settlement if it has been set as the settlement currency already！',
        add_mid:'Add',
        open:"Active",
        closed:'Inactive',
        add_notice:'Add',
        add_black:'Add',
        add_member:'Add',
        add_role:'Add',
        role_name:'Admin GRP Name',
        update_role:'Update',
        role_limit:'Assign Access',
        mode_name:"Module Name",
        ass_team:'Assign',
        slidedown:"More",
        slideup:'Closed',
        release_now:'Release Now',
        ready_released_money:'Pending Released AMT*',
        already_released_money:' Released AMT*',
        s_time:'STAT* Time',
        add:'Add',
        batchadd:'Batch Add',
        is_released:'IsReleased'  ,
        black_value:'Blacklist Value',
        black_text:'As long as one of the source IP, country , email address and phone number of transaction is on the blacklist，system will directly block the transaction！',
        test:'Test',
        refund_time:'Refund Time',
        chargeback_time:'Chargeback Time',
        ban_time:'Ban Time',
        tot:'TOT : {total} ',
        white_tips:'You can add the first six digits and the last four digits of the credit card as whitelists, which means only the card of transactions involved in the whitelist can be accepted by the platform!',
        order_success_time:'Transaction Approved Time',
        order_failed_time:'Transaction Declined Time',
        order_status_tips:'This information is only for reference,please subject to the final payment result!',
        no_order_info:'Sorry,The information does not exist!',
        is_allow_support_direct_pay:'Enable Direct API',
        trans_limits:'TRANS Limits',
        app_add_msg:'App just added!',
        is_default:'Default',  
        generate_report:'Generate report',
        report_tips:'It will take several minutes or longer to generate a report, please view it later.',
        receive_email:'Email',
        fraud_time_range:'Fraud Time Range',
        online:'Online',
        offline:'Offline',
        edit:'Edit',
        full_refund:'Full Refund',
        refund_statistic:'Refund Statistic',
        refund_success:'Refund Success',
        refund_accept:'Refund accepted',
        refund_fail:'Refund Failed',
        include_refund:'Including refund',
        without_refund:'Without refund',
        history_trans_profits:'Historical Trans* Profits',
        pay_method:'Payment Method',
        pay_method:'Payment Mode',
        my_qrcode:'My Qrcode',
        syn_asyn_url:'Syn/Asyn Notification URL',
        syn_url:'Syn notification URL',
        asyn_url:'Asyn notification URL',
        refund_history:'Refund History',
        download_qr:'Download Qrcode',
        query_refund:'Query Refund',

        choose_role:"Department list",
        choose_mid:'Merchant List',
    },

    setting: {
        basic_info: "Basic Info",
        preferences: "Preferences",
        security: "Security",
        user_name: "User Name",
        tel:'Tel',
        two_fa_code:"2 Factor Code",
        register_date: "Registry Time",//jan bug 1027
        last_login_date:'Last Login Time', //jan
        last_login_ip:'Last Login IP',
        last_login_app:'Last Login Device',//jan

        default_language: "Default Email Language",
        default_time_zone: "Default Time Zone",
        login_pwd: "Login Password",
        two_step: "2-Step Authentication",//jan
        change_pwd: "Change Password",
        new_pwd: "New Password",
        two_fa_secret:'2 Factor Secret',
        edit_email:'Change Email', 
        new_email:'New Email',
        email_tips:'You’ll be requested to sign in again and rebind 2-Step Authentication after changing your email.',
        notice:'Tips',
        notice_text:'Please reach us at  following email if you have any questions regarding  your account！',
        version:'New system available,please update to the latest version',
        change_mid:'Switch to another MID',
        default:'Default',    
        ord_stat:'ORD Status',
    },

    

    error: {
        check_network: "Check Network",
        no_resource: "No Resource",
        sys_error: "System Error",
    },

 

   
    bottomtips:{
        a:'Email is the unique identifier for account registry and management , you can use it to retrieve your password or contact us for assistance in any issues.',
        b:'Merchant ID corresponds to one business entity, you can apply multiple MIDs with same email.You should activate at least one MID for processing.',
        c:'APP generally refers to payment scenarios of merchant which can be divided into online APP and offline APP. The former mainly refers to payment operations on PC website /mini-program/ mobile APP/ Phone Browser while the latter mainly refers to payment scenarios such as face-to-face QR code, barcode scanner, and face swiping used in offline stores like supermarkets and hotels.',
        d:'In order to prevent the account from being used illegally , we require merchant to enable 2-Step Authentication to ensure security of merchant accounts and funds to the greatest extend.',
        // e:'5.为了防止帐户被非法使用，我们强制启用两步验证，最大限度保证客户的资金安全。',
        // f:'6.如果您在使用系统的过程中有任何问题，都可以联系我们：support@ipassbill.com',
    },
  
    // 
    orderStatus:{
        1:'Pending ', 
        2:'Approved', 
        3:'Declined',
        4:'Authorized ',
        5:'Captured ',
        6:'Voided  ',
        7:'Pending Refund',
        8:'Refunded ',
        9:'Chargeback ',
        10:'Chargeback Reversed',
    },

    orderStatus_list:{
        Pending:'Pending ', 
        Approved:'Approved', 
        Declined:'Declined',
        Authorized:'Authorized ',
        Captured:'Captured ',
        Voided:'Voided  ',
        Pending:'Pending Refund',
        Refunded:'Refunded ',
        Chargeback:'Chargeback ',
        Reversed:'Chargeback Reversed',
    },

    // 
    errPsw:{
        pws_text:"Your password must be 8-20 characters long, should contain uppercase letter, lowercase letter,special symbols(#?!@$%^&*-)and digit."
    },

    period_list:{
        0:'Today Review',
        1:'YTD Review',
        2:'CUR* MN* Review',
        3:'LST MN* Review',        
        4:'CUR* YR*  Review',
    },

    blackTypeList:{
        1:'Credit Card',
        2:'Email',
        3:'Tel',
        4:'Country',
        5:'IP Address',
    },
    logtype:{
        1:'Log In',
        2:'Log Out',
        3:'Add',
        4:'Update',
        5:'Delete'
    },
    merchantStatus:{
        1:"Pending",
        2:"Pending Check",
        3:"Active",
        4:"Inactive" 
    },
    userStatus:{
        1:"Active",
        2:"Restricted",
        3:"Inactive",
    },
    
    merchants_tips:{
        tips:"Suggested Value",
        tips_1:"When main currency converts into the channel currency, the additional percentage of channel amount is m and default m=0. For example, the main currency of the merchant account is a and the channel currency is b. Assuming 1a = xb, and the merchant's main currency amount is equal to 1, then the channel amount b should normally be (1 + m) x. We can see it's more favorable for the platform when m>=0. The above condition is also valid for the situation of a and b in same currency.",
        tips_2:"When the currency of the transaction is converted into the main currency of the merchant account, the additional reduction percentage of the merchant account amount is n and default n=0. For example, the order currency is a, the merchant's main currency is b, assuming 1a = xb, and the order currency amount is equal to 1, then under normal circumstances, the merchant account's main currency amount should be (1-n) x. Here you can see: n<=0, it is more favorable for the platform. In particular, when a and b are in same currency, n does not take effect, that is, n is directly 0."
    },
    version_desc:{
        text:'Version'
    },
    version:{
        1:'1.0',
        2:'2.0',
        3:'3.0'    
    },
    pwd:{
        text:'Leave blank means keep the password the same ！'
    },

    account_info:{
        pwd:'Password',        
        // merchant_currency:'MERCH Default CURR*',
        merchant_currency:'Settlement Currency',
        reset_two_fa_code:'Reset 2 factor code',
        is_bind_two_fa_code:'Enable 2-Step authentication?',
        admin_remark:'Admin Remark', 
        his_rolling:'Grand total of RR*', 
        isp_remark:'ISP Remark',
    },

    // 主体信息相关
    subject:{      
        entity_tel:'Company Tel',    
        subject_title:'Company Info', 
        company_name:'Company Name', 
        entity_name:'Company Name', 
        company_postcode:'Company Postcode', 
        service_cate:'Industry Category', 
        service_cate_desc:'Industry DESCR*',
        company_address:'Company Address', 
        person_address:"Legal Person Address", 
        legal_name:'Legal Person Name', 
        legal_phone:'Tel', 
        legal_postcode:'Legal Person Postcode',       
        web_site:'Website', 


    },


    //商户详情. 变量暂时用1234，有个更好的在替换
    merchants_info:{
        merchant_title:'Merchant Info',
        merchant_currency:'Default CURR*',   
        his_rolling:'Grand total of RR*',         
        limit_title:'Restrictions', 
        card_max_times:'TRANS* LIM* CNT(/DY/CRD)',
        card_success_times:'Success LIM* CNT(/DY/CRD)',
        bill_max_times:'TRANS* LIM* CNT(/DY/CUST*)', 
        bill_success_times:'Success LIM* CNT(/DY/CUST*)',
        trading_title:'Fees', //jan
        transaction_ratio_fee:'MDR', //jan
        transaction_roll_duration:'RR Period', 
        refund_fee:'Refund Fee',
        guaranty_duration:'Settlement Cycle', //
        transaction_fixed_fee:'Fixed Fee', 
        transaction_roll_ratio:'RR ratio', 
        protest_fee:'Chargeback Fee',
        factor_title:'ROE DIFF Factor / TRANS* Factor',
        exchange_factor:'ROE DIFF Factor', 
        transaction_factor:'TRANS* Factor',
        
        withdraw_title:'Withdrawal Related', 
        withdraw_ratio_fee:'Withdrawal Ratio', 
        withdraw_fixed_fee:'Withdrawal Fee', 
        withdraw_min_amount:'Withdrawal Min. AMT*', 
        withdraw_max_amount:'Withdrawal Max. AMT*', 

        is_withdrawal:'Withdrawal Status',//jan
        is_allow_diff_bankaccount:'Is allowed to add different-name bank account',
        day:'Day(s)',//jan
        times:'CNT',
        no_see:'IsVisible',
        account_checking:'Operate',
        download:'Download File',
        available_channel_mid:"AVL Channel MID",
        inavailable_channel_mid:"Not AVL Channel MID",
        info:'Merchant Info',
        bank:'Bank',
        white_card:"Whitelist",
        open_white_card:'Activate Whitelist',
        limit_in:'From 0-100, 0 means unrestricted.',
        apidoc:"API Document",
        withdrawal_frequency:'Withdrawal Frequency (N)',
        currency_tips:'Every merchant account is able to set a unique settlement currency ,which cannot be modified after setting.Please confirm the settlement currency before submitting for review.'



    },
    merchant_withdraw_type:{
        1:'CNT*/Day ',
        2:'CNT*/Week ',
        3:'CNT*/Month '
    },
     
    app_info:{
        type:"APP Type",
        card_type:"Card Type",
        choose_channel:'Channel',
        meta:'Meta Identifier ', 
        order_currency:'ORD Currency',
        order_amount_range:'ORD AMT* Range', 
        channel_mid_info:'Channel MID Info', 
        priority:'Priority', 
        gateway_currency:'Channel Settlement CURR*',
        failed_reason:'Declined Reason',
        need_delivery:'Need Delivery',//jan



    },  

    withdraw_info:{
        withdraw_title:'Withdrawal Bank Account',                
        bank_info:'Bank Info', 
        bank_account_number:'Account NO.', 
        // bank_account_name:'ACCT*', 
        bank_account_name:'Bank ACCT* Name', //jan bug 1078
        bank_name:'Bank Name', 
        swift_code:'SWIFT',
        // swift_code:'SWIFT',
        bank_branch:'Intermediary Bank',
        bank_country:'Bank Country',  
        account_country:'Account Country',     
        width_title:'Check', 
        check_withdraw:'Check',
        confirm_withdraw:'Confirm',

        withdraw_tips:'Current account unsettled transaction is <span class="uk-text-danger">{total_deal_amount}</span> {merchant_currency} （<span class="uk-text-danger">{total_deal_count}</span> CNT）, unsettled amount is  <span class="uk-text-danger">{net_deal_amount}</span> {merchant_currency}.（<span class="uk-text-danger">{start_date}</span>-<span class="uk-text-danger">{end_date}</span>）'        
        // withdraw_tips:'There are totally <span class="uk-text-danger">{total_deal_count}</span> approved transactions with amount <span class="uk-text-danger">{total_deal_amount}</span> {merchant_currency} from <span class="uk-text-danger">{start_date}</span> to <span class="uk-text-danger">{end_date}</span>, and the net settlement amount is <span class="uk-text-danger">{net_deal_amount}</span> {merchant_currency}（funds on hold)'     




    
    },
    business_info:{

        basic_info:'Basic Info', 
        mode_desc:'Trans Mode', 
        gateway_amount:'Gateway AMT*', 
        gateway_available_amount:'Remaining AMT*',
        risk_time:'Risk Time', 




        bill_desc:'Billing Info',//jan
        risk_desc:'Risk Description',
        
        order_history:'ORD History',
        merchant_amount:'Settlement AMT*',   
        gateway_amount:'Gateway AMT*',
        
        rolling_title:'Rolling Reserve',
        rolling_ratio:'RR Ratio',
        rolling_back_day:'Days on Hold',//jan
        rolling_released_time:'Released Time',        
        rolling_ready_released_time:'(EST*) Released at',//jan
        rolling_already_released_time:'Released Time',

        fee_title:'Fee Standards',
        exchange_roe:'ROE Difference',
        gateway_roe:'Exchange Rate',
        rolling_day:'Holding Period',
        fixed_fee:'Fixed Fee',
        process_ratio:'MDR',//jan
        transaction_total_fee:'Total  Trans* Fee',  //jan bug 911
        refund_fee:'Refund Fee',
        protest_fee:'Chargeback Fee',
        
        card_title:'Credit Card',
        card_holder:'Card Holder',
        expiry_time:'Expiry Time',
        
        act_record:'Action Record',

        
        act_exception:'Ignore Exception',
        
        success_btn:'Process to success',
        refused_btn:'Reject',
        authorization_btn:'Authorization',
        cancel_btn:'Cancel',
        refound_btn:'Refund',        
        catch_btn:'Capture',
        cancle_refound_btn:'Cancel Refund',
        cancle_channel_refound_btn:'Cancel Channel Refund',
        over_refound:'Refunded',
        refuse_pay_btn:'Chargeback', 
        cancel_chargeback:'Chargeback Reversed',
        refund_plan:'Refund Plan',
        action:'Action',
        gateway_serial_no:'Channel Ref. No.', 
        ignore_exception:'Ignore',
        available_amount:'Available Amount',
        refound_amount:'Refund Amount',
        remain_available_amount:'Remain AVL* AMT*',
        fully_refunded:'Transaction is fully refunded.',
        refund_delay_hour:'Please initiate a refund when the transaction is completed after {hour} hour(s)! '




    },
    refund:{
        mch_refund_no:'MERCH Refund No.',
        refund_stat:'Refund Status',
        refund_type:'Refund Type',
        refund_order_no:'Refund No.',
        order_amount:'Order AMT*',
        refund_amount:'Refund AMT*',
        merchant_refund_amount:'MERCH Refund AMT*',
        channel_refund_no:'Gateway Refund No.',
        gateway_refund_amt:'Gateway Refund AMT*',
        refund_type:'Refund Type',
    },

    address_info:{
        shipping:'Shipping Info',
        shipping_address:'Billing Address',
        state:'State/Province', //jan
        address:'Address',
        tel:'Tel',
        postcard:'Postcode',
        email:'Email',
        name:'Name',
        shipping_allow:'Shipping Tracking',
        first_name:'First Name',
        last_name:'Last Name',   
        city:'City',
        street:'Street',
        enable_all:'Enable all',
        disable_all:'Disable all',
        enable_page:'Enable this page',
        disable_page:'Disable this page'

    },
    express_info:{
        company_code:'Company name abbr./Code',
        edit:'Edit',
        add:'Add',
        update_shipping_no:'Update Shipping Info.'


    },
    shipping:{
        is_shipping:'IsDelivered', 
        upload_time:'Upload Time', 
        create_time:'Create Time', 
        express_company:'Express Company'
    },
    config:{
        
        icon:'Icon', 
        emailLogo:'Email Logo', 
        merchant_web_siet:'Merchant Domain',
        api_resourse:'API Interface Domain', 
        service_api:'Admin Domain',
        icp:'ICP', 
        solgan:'Slogan',
        institution_name_name:'Institution Name', 
        support_area:'Supported Area', 
        is_open_gateway:'Enable Gateway', 
        is_closed_web:'Disable MERCH dashboard', 
        support_currency:'Supported Currency',



    },
    member_info:{
        two_fa:"Two-Factor Verification",

    },
    notice_info:{
        add_lang:'Add LNG', 
        lang_text:"Now you can add Multilingual system notice. ",
        all:'ALL',
        merchant:'Merchant',
        merchant_list:'Merchant List'
    },
    batchadd:{        
        xlsx_text:'Please download the xlsx file for batch-adding delivery. Please add your shipping information in accordance with the format required in the xlsx file. Click the button to upload after completing.',
        app_text:'Please download the xlsx file for batch-adding APP. Please add your APP information in accordance with the format required in the xlsx file. Click the button to upload after completing. ',
        white_text:'Please download the xlsx file for batch-adding whitelists. Please add your whitelist information in accordance with the format required in the xlsx file. Click the button to upload after completing.  ',        




    },
    account_status:{
        1:'Active',
        2:'Inactive',
        3:'Restricted'
    },
    app_status:{
        0:'Pending Check',         
        1:'Active',
        2:'Inactive'
    },
    withdraw_status:{
        1:'Success', 
        2:'Pending Check', 
        3:'Declined', 
        4:'Pending Payout', 
    },
   
    statement_info:{
        total:'Total',
        change:'Reserve Change'

    },
    channel_info:{
        merchant_secret:'Merchant Secret',
        version:'Version',
        vaild:'Valid',
        invaild:'Invaild'
    },
    role:{
        title:'Role Title',        
    },
    index_review:{
        all:"ALL",
        success:'Approved', 
        authorized:'Authorized',
        captured:'Captured',
        refound:'Refunded',
        chargeback:'Chargeback',
        pending:'Pending',
        voided:'Voided',
        failed:'Declined',
        pending_refound:'Pending Refund',
        cancel_protest:'Chargeback Reversed',
        get_protest:'STAT*/ Chargeback TM',
        stataic_time:'STAT*/ Chargeback TM'
    },
    statement_type:{
        1:'Transaction Approved',                                
        2:'Transaction Refunded',
        3:'Chargeback',
        4:'Reserve Released',
        5:'Withdraw Money',
        6:'Withdrawal Canceled',
        7:'Transfer In',
        8:'Transfer Out',
        9:'Declined',
        // <!-- 10:交易预争议, -->
        11:'Chargeback Reversed ',
        12:'Freeze Funds',
        13:'Unfreeze Funds',
        // 14:"Account Statement",
        // 15:"Faile",
        20:'Transaction Fee',
        21:'Chargeback Fee',
        22:'Refund Fee',
        23:'Withdrawal Fee',
        24:'Other Fees',
    },


    
    //邮件类型
    email_type:{
        withdraw_success_notify:'Withdrawal Completed',
        withdraw_success_notify_desc:'A notification email will be sent if merchant’s withdrawal request has been reviewed and approved by platform.',
        merchant_payment_notify:'Send payment success notification to merchant.', 
        merchant_payment_notify_desc:'A notification email will be sent to merchant if payment success.', 
        customer_payment_notify:'Send payment success notification to customer.', 
        customer_payment_notify_desc:'A notification email will be sent to customer if payment success.', 
        withdraw_rejected_notify:'Withdrawal Declined', 
        withdraw_rejected_notify_desc:'A notification email will be sent to merchant if withdrawal declined by platform.', 
        trans_in_notify:'Transfer In', 
        trans_in_notify_desc:'A notification email will be sent to merchant if there is transfer-in payment.', 
        trans_out_notify:'Transfer Out', 
        trans_out_notify_desc:'A notification email will be sent to merchant if there is transfer-out payment.', 
        frozen_notify:'Freeze Money',  //jan
        frozen_notify_desc:'A notification email will be sent to merchant if funds manually frozen.', 
        unfreeze_notify:'Unfreeze Money', //jan
        unfreeze_notify_desc:'A notification email will be sent to merchant if funds manually unfrozen.', 
        charge_back_notify:'Chargebacks/Frauds',
        charge_back_notify_desc:'A notification email will be sent to merchant if there is chargeback/fraud.',
        cancel_charge_back_notify:'Chargeback Reversal',
        cancel_charge_back_notify_desc:'A notification email will be sent to merchant if there is chargeback reversal.',
        fee_notify:'Charge fees',
        fee_notify_desc:'System notifies merchant when it  processing the charge',        
    },
    merchant:{
        add:'Create Merchant',
        company_info:'Company Info',
        honor_info:'Certificates Info',
        honor:'Company Certificates',
        file_info:'Required Files',
        zip:"Files need to be uploaded in zip or rar format,The size of the uploaded file cannot exceed 8M. <span class='uk-text-danger'>( Added files will overwrite previous files.  )</span>",        
        terms_text:'By submitting this form, you confirm that you agree to  our Terms of Service, and accept automated email from us, also confirm that the information you provided is complete and accurate.',//jan
        confirm_apply:'Submit',
        save:'Save',
        update_merchant:'Update Merchant Info',
        kyc:'Upload Files',
        uploaded:'File uploaded...',
        tips:'',
        
        
        nopost_text:'MID not submitted to check!!',
        applying_text:'Your KYC file is under review, please be patient to wait!',
        close_text:'Merchant Account Disabled!',
        back_index:'Back',
        legal_info:'Legal Person Info',
        withdraw_range:'AVL WDRL Range',
        no_limit:'No Limites',
        is_open_white:'Whitelist Status', //jan
        email_config:'Email Config',
        // email_tips:'You can customize email notification for each Merchant ID, email will be sent to：',
        email_tips:'You can customize the receiving mailbox for each type of email, if not set, the content will be sent to:',
        custom_email:'Your Custom Email',
    },

    withdraw:{
        withdraw_list:'WDRL List',
        my_bank:'My Bank ',
        withdraw_amt:'Amount',
        add_bank:'Add Bank',
        withdraw_now:'Withdraw Now',
        tips:'Your merchant account is unable to withdraw ,please reach us at {email} for further assistance.',
        no_bank:'You haven’t added any bank account!',
        available_withdraw_amount:'AVL WDRL AMT*',
        card_info:'Account No.',
        bank_address:"Bank Address",
        if_any:'Intermediary Bank (If any)',
        payee_country:'Payee Country',
        payee_address:'Payee Address',
        withdraw_text:'Please ensure all account information you entered is accurate. We will not be responsible for any transfer problems caused by incorrect information entry! ',//jan
        add_bank_text_1:'Note, you can only add bank account named <span class="uk-text-danger"><i>{name}</i></span> ! Please make sure account can accept <span class="uk-text-danger"><i>{currency}</i></span> before adding.',
        
        add_bank_text_2:'Note,Please make sure account can accept <span class="uk-text-danger"><i>{currency}<i></span> before adding.',
    },

    file_info:{
        1:'a）Scanned copy of Business Incorporation：Business name, registration number/date/address should be clearly displayed',
        2:'b）Scanned copy of ID/Passport of all directors',
        3:'c）Scanned copy of ID/Passport of UBO holding more than 25% shares ownership',
        4:'d）At least 2 recent photos of the company owner, should clearly show the face',
        5:'e）Business card for at least one authorized representative  (optional)',
        6:'f）At least 2 office photos with company brand',
        7:'g）Copy of the company’s gas/water/electricity bills statement in recent 3 months',
        8:'h）Copy of company’s bank statement for recent 3 months'
    },
    risk_type:{
        1:'IP',
        2:'Country',
        3:'Email',
        4:'Tel',            
        5:'Credit Card'
    },
    egret_server:{
        1:'Tangible Products',
        2:'Advertising / Marketing / Media Services',
        3:'Electrical / Cabling Local Service',
        4:'Engineering Services',
        5:'Event Management Membership/Booking ',
        6:'Recruitment / HR Services ',
        7:'Membership Clubs/ Country Clubs/ And Private Golf Courses ',
        8:'Finance',
        9:'Software / File Hosting/ PC Support',
        10:'Downloads(Music/ Movies/E-Book/Picture Spread ）',
        11:'Dating Service',
        12:'Multi-Level Marketing',
        13:'Lodging-Hotels/ Motels/ And Resorts / Timeshares / Travel',
        14:'Nutraceuticals / Skin Care / Natural Supplements',
        15:'Natural Herbs / Herbal',
        16:'Chemicals ',
        17:'E-Cigarette / Tobacco',
        18:'Replica ',
        19:'Gaming',
        20:'Adult',
        21:'Drug Stores And Pharmacies',
        22:'Others'       
    }

}


// WEBPACK FOOTER //
// ./src/components/common/resouces/lang/en.js